import { default as _91_46_46_46cms_93rBNdpM3wA4Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93s4leR6LlRQMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/3d-projects/[...slug].vue?macro=true";
import { default as indexcur8j6lCibMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93761XtBqjb7Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/akcii/[...slug].vue?macro=true";
import { default as indexfk02K5BCjIMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_93pujAuIdgxSMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/articles/[...slug].vue?macro=true";
import { default as index3GEeRxzHcOMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/articles/index.vue?macro=true";
import { default as index7CTl6xexCrMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/authorization/index.vue?macro=true";
import { default as indexJ40VbaUB2wMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_93VjDyv7s8AQMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93s4iHQuSsLRMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/catalog/[...slug].vue?macro=true";
import { default as indexpJNgwPEcLPMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_937ZS6L8MxB0Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultofBidwVEhUMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/catalogsearch/result.vue?macro=true";
import { default as indexKn4FLe4o0EMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93OvLO9GzD8FMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93KLSdHjJ4L6Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/fabriki/[...slug].vue?macro=true";
import { default as indexymyyFdmhADMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/fabriki/index.vue?macro=true";
import { default as _91_46_46_46slug_93zf2FlgvpWqMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/product/[...slug].vue?macro=true";
import { default as index2Tq45hPA4bMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/profile/index.vue?macro=true";
import { default as indexnxHM64r65aMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/profile/orders/index.vue?macro=true";
import { default as indexPGzheczxMbMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93KmgyWRXKEJMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/sets/[...slug].vue?macro=true";
import { default as indexlgxosiBAutMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93rBNdpM3wA4Meta?.name ?? "cms",
    path: _91_46_46_46cms_93rBNdpM3wA4Meta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93rBNdpM3wA4Meta || {},
    alias: _91_46_46_46cms_93rBNdpM3wA4Meta?.alias || [],
    redirect: _91_46_46_46cms_93rBNdpM3wA4Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93s4leR6LlRQMeta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_93s4leR6LlRQMeta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_93s4leR6LlRQMeta || {},
    alias: _91_46_46_46slug_93s4leR6LlRQMeta?.alias || [],
    redirect: _91_46_46_46slug_93s4leR6LlRQMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexcur8j6lCibMeta?.name ?? "3d-projects",
    path: indexcur8j6lCibMeta?.path ?? "/3d-projects",
    meta: indexcur8j6lCibMeta || {},
    alias: indexcur8j6lCibMeta?.alias || [],
    redirect: indexcur8j6lCibMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93761XtBqjb7Meta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93761XtBqjb7Meta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93761XtBqjb7Meta || {},
    alias: _91_46_46_46slug_93761XtBqjb7Meta?.alias || [],
    redirect: _91_46_46_46slug_93761XtBqjb7Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexfk02K5BCjIMeta?.name ?? "akcii",
    path: indexfk02K5BCjIMeta?.path ?? "/akcii",
    meta: indexfk02K5BCjIMeta || {},
    alias: indexfk02K5BCjIMeta?.alias || [],
    redirect: indexfk02K5BCjIMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93pujAuIdgxSMeta?.name ?? "articles-slug",
    path: _91_46_46_46slug_93pujAuIdgxSMeta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_93pujAuIdgxSMeta || {},
    alias: _91_46_46_46slug_93pujAuIdgxSMeta?.alias || [],
    redirect: _91_46_46_46slug_93pujAuIdgxSMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index3GEeRxzHcOMeta?.name ?? "articles",
    path: index3GEeRxzHcOMeta?.path ?? "/articles",
    meta: index3GEeRxzHcOMeta || {},
    alias: index3GEeRxzHcOMeta?.alias || [],
    redirect: index3GEeRxzHcOMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: index7CTl6xexCrMeta?.name ?? "authorization",
    path: index7CTl6xexCrMeta?.path ?? "/authorization",
    meta: index7CTl6xexCrMeta || {},
    alias: index7CTl6xexCrMeta?.alias || [],
    redirect: index7CTl6xexCrMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexJ40VbaUB2wMeta?.name ?? "cart",
    path: indexJ40VbaUB2wMeta?.path ?? "/cart",
    meta: indexJ40VbaUB2wMeta || {},
    alias: indexJ40VbaUB2wMeta?.alias || [],
    redirect: indexJ40VbaUB2wMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_93VjDyv7s8AQMeta?.name ?? "cart-success-id",
    path: _91_46_46_46id_93VjDyv7s8AQMeta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_93VjDyv7s8AQMeta || {},
    alias: _91_46_46_46id_93VjDyv7s8AQMeta?.alias || [],
    redirect: _91_46_46_46id_93VjDyv7s8AQMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93s4iHQuSsLRMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93s4iHQuSsLRMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93s4iHQuSsLRMeta || {},
    alias: _91_46_46_46slug_93s4iHQuSsLRMeta?.alias || [],
    redirect: _91_46_46_46slug_93s4iHQuSsLRMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexpJNgwPEcLPMeta?.name ?? "catalog",
    path: indexpJNgwPEcLPMeta?.path ?? "/catalog",
    meta: indexpJNgwPEcLPMeta || {},
    alias: indexpJNgwPEcLPMeta?.alias || [],
    redirect: indexpJNgwPEcLPMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_937ZS6L8MxB0Meta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_937ZS6L8MxB0Meta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_937ZS6L8MxB0Meta || {},
    alias: _91_46_46_46slug_937ZS6L8MxB0Meta?.alias || [],
    redirect: _91_46_46_46slug_937ZS6L8MxB0Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultofBidwVEhUMeta?.name ?? "catalogsearch-result",
    path: resultofBidwVEhUMeta?.path ?? "/catalogsearch/result",
    meta: resultofBidwVEhUMeta || {},
    alias: resultofBidwVEhUMeta?.alias || [],
    redirect: resultofBidwVEhUMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: indexKn4FLe4o0EMeta?.name ?? "clear-page-slider",
    path: indexKn4FLe4o0EMeta?.path ?? "/clear-page-slider",
    meta: indexKn4FLe4o0EMeta || {},
    alias: indexKn4FLe4o0EMeta?.alias || [],
    redirect: indexKn4FLe4o0EMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93OvLO9GzD8FMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93OvLO9GzD8FMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93OvLO9GzD8FMeta || {},
    alias: _91_46_46_46slug_93OvLO9GzD8FMeta?.alias || [],
    redirect: _91_46_46_46slug_93OvLO9GzD8FMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93KLSdHjJ4L6Meta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_93KLSdHjJ4L6Meta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_93KLSdHjJ4L6Meta || {},
    alias: _91_46_46_46slug_93KLSdHjJ4L6Meta?.alias || [],
    redirect: _91_46_46_46slug_93KLSdHjJ4L6Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexymyyFdmhADMeta?.name ?? "fabriki",
    path: indexymyyFdmhADMeta?.path ?? "/fabriki",
    meta: indexymyyFdmhADMeta || {},
    alias: indexymyyFdmhADMeta?.alias || [],
    redirect: indexymyyFdmhADMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93zf2FlgvpWqMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93zf2FlgvpWqMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93zf2FlgvpWqMeta || {},
    alias: _91_46_46_46slug_93zf2FlgvpWqMeta?.alias || [],
    redirect: _91_46_46_46slug_93zf2FlgvpWqMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index2Tq45hPA4bMeta?.name ?? "profile",
    path: index2Tq45hPA4bMeta?.path ?? "/profile",
    meta: index2Tq45hPA4bMeta || {},
    alias: index2Tq45hPA4bMeta?.alias || [],
    redirect: index2Tq45hPA4bMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexnxHM64r65aMeta?.name ?? "profile-orders",
    path: indexnxHM64r65aMeta?.path ?? "/profile/orders",
    meta: indexnxHM64r65aMeta || {},
    alias: indexnxHM64r65aMeta?.alias || [],
    redirect: indexnxHM64r65aMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexPGzheczxMbMeta?.name ?? "recently",
    path: indexPGzheczxMbMeta?.path ?? "/recently",
    meta: indexPGzheczxMbMeta || {},
    alias: indexPGzheczxMbMeta?.alias || [],
    redirect: indexPGzheczxMbMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93KmgyWRXKEJMeta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93KmgyWRXKEJMeta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93KmgyWRXKEJMeta || {},
    alias: _91_46_46_46slug_93KmgyWRXKEJMeta?.alias || [],
    redirect: _91_46_46_46slug_93KmgyWRXKEJMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexlgxosiBAutMeta?.name ?? "wishlist",
    path: indexlgxosiBAutMeta?.path ?? "/wishlist",
    meta: indexlgxosiBAutMeta || {},
    alias: indexlgxosiBAutMeta?.alias || [],
    redirect: indexlgxosiBAutMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260831070650/pages/wishlist/index.vue").then(m => m.default || m)
  }
]